import type { VideoBarProps } from './video-bar.component';

/**
 * Maps HTML attribute names (kebab-case) to VideoBar prop names (camelCase)
 */
export const VIDEO_BAR_ATTRIBUTE_MAP: Record<string, keyof VideoBarProps> = {
  title: 'title',
  description: 'description',
  tags: 'tags',
  sort: 'sort',
  'max-videos': 'maxVideos',
  'all-videos': 'allVideos',
  'show-view-all': 'showViewAll',
  'show-badge': 'showBadge',
  'show-video-title': 'showVideoTitle',
  'show-video-date': 'showVideoDate',
  'show-video-artist': 'showVideoArtist',
  'show-card-drop-shadow': 'showCardDropShadow',
  'max-width': 'maxWidth',
  display: 'display',
  'badge-text': 'badgeText',
  'display-type': 'displayType',
  'title-size': 'titleSize',
  'logged-in': 'loggedIn',
  'card-border-radius': 'cardBorderRadius',
  'column-count': 'columnCount',
  'text-color': 'textColor',
  background: 'background',
  'badge-color': 'badgeColor',
  'badge-background': 'badgeBackground',
  'loading-background': 'loadingBackground',
  'vertical-padding': 'verticalPadding',
  'horizontal-padding': 'horizontalPadding',
  'thumbnail-height': 'thumbnailHeight',
};

/**
 * Properties that should be converted from string to boolean
 */
const BOOLEAN_PROPS = new Set([
  'allVideos',
  'loggedIn',
  'maxWidth',
  'showViewAll',
  'showBadge',
  'showVideoTitle',
  'showVideoDate',
  'showVideoArtist',
  'showCardDropShadow',
]);

/**
 * Converts a string attribute value to the appropriate type
 */
function convertAttributeValue(propName: string, value: string): any {
  if (BOOLEAN_PROPS.has(propName)) {
    // Convert string "true"/"false" to boolean
    return value === 'true';
  }
  return value;
}

/**
 * Extracts attributes from an HTMLElement and converts them to VideoBarComponent props
 */
export function extractVideoBarAttributes(element: HTMLElement): Partial<VideoBarProps> {
  const props: Partial<VideoBarProps> = {};

  for (const [attrName, propName] of Object.entries(VIDEO_BAR_ATTRIBUTE_MAP)) {
    const value = element.getAttribute(attrName);
    if (value !== null) {
      (props as any)[propName] = convertAttributeValue(propName, value);
    }
  }

  return props;
}
